// @flow

import * as React from 'react';

import { useDispatch } from 'react-redux';
import {
  Outlet,
  ScrollRestoration,
  useNavigate,
  useParams,
} from 'react-router-dom';
import { compose } from 'redux';

import { withPageMeta } from '@gandi/app-runner';
import { selectTotalProducts, selectOneProductById } from '@gandi/cart';
import { selectCurrentId, setCurrentId } from '@gandi/redux-sharing';

import { useAppSelector } from 'src/hooks/useAppSelector';

function CartConfigure(): React.Node {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { cartId, productId } = useParams<{
    cartId: string,
    productId?: string,
  }>();
  const sharingId = useAppSelector(selectCurrentId);
  const cartTotalProducts = useAppSelector(selectTotalProducts);
  const product = useAppSelector(state =>
    productId
      ? selectOneProductById(state, {
          productId,
        })
      : undefined,
  );

  const [initialSharingId, setInitialSharingId] = React.useState(undefined);

  const willMount = React.useRef(true);
  React.useEffect(() => {
    // $FlowFixMe[incompatible-call]
    setInitialSharingId(sharingId);
    if (willMount.current) {
      if (global.__CLIENT__) {
        if (cartTotalProducts <= 0 || (productId && !product)) {
          navigate(`/cart/${cartId}/overview`, {
            replace: true,
          });
        }
      }
      willMount.current = false;
    }

    return () => {
      if (initialSharingId && initialSharingId !== sharingId) {
        dispatch(setCurrentId(initialSharingId));
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <Outlet />
      <ScrollRestoration />
    </>
  );
}

export default (compose(
  withPageMeta(args => ({
    title: args.__('Configure your domain contacts - Gandi.net'),
  })),
)(CartConfigure): React.ComponentType<{}>);
